/**
 * @fileoverview Model for a Yelp configuration.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */

import {LinkedAccount, LinkedAccountJson} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/linkedaccount';
import {SyncedFieldSetting, SyncedFieldSettingJson} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/syncedfieldsetting';

export class YelpConfiguration {
  /** @return {YelpConfiguration} */
  static empty() {
    return new YelpConfiguration({
      linkedAccount: undefined,
      skipSetup: false,
      syncedFieldSettings: [],
    });
  }

  /**
   * @param {{
   *  linkedAccount: (LinkedAccount | undefined),
   *  skipSetup: boolean,
   *  syncedFieldSettings: !Array<SyncedFieldSetting>,
   * }} params
   */
  constructor(params) {
    /** @type {LinkedAccount | undefined} */
    this.linkedAccount = params.linkedAccount;
    /** @type {boolean} */
    this.skipSetup = params.skipSetup;
    /** @type {!Array<SyncedFieldSetting>} */
    this.syncedFieldSettings = params.syncedFieldSettings;
  }

  /**
   * @return {!YelpConfigurationJson}
   */
  toJSON() {
    return {
      'linkedAccount': this.linkedAccount?.toJSON(),
      'skipSetup': this.skipSetup,
      'syncedFieldSettings': this.syncedFieldSettings.map(sfs => sfs.toJSON()),
    };
  }
}

/**
 * @dict
 * @typedef {{
 *  linkedAccount: (LinkedAccountJson | undefined),
 *  skipSetup: boolean,
 *  syncedFieldSettings: !Array<SyncedFieldSettingJson>,
 * }}
 */
export let YelpConfigurationJson;

export const YelpEnterprisePublisherId = 588;
export const YelpKnowledgePublisherId = 792;
